import Graph from "../util/graph";


const managerAnalyticsDataFinder = (
    managerUserAnalytics,
    allDates,
    isDateSummed,
    selectedManagers,
    isBar,
    isDataTabular,
    sHotels,
    isHotelSummed,
) => {

    const managerIds = selectedManagers.map(it => it.id)

    if (!isHotelSummed && !isDateSummed) {
        if (isBar) {
            return selectedManagers.map((manager, mIndex) => {
                return sHotels.map((hotel, index) => {
                    return {
                        label: `${hotel} ${manager.name}`,
                        data: allDates.map((date) => {
                            if (managerUserAnalytics[hotel][date] && managerUserAnalytics[hotel][date][manager.id]) {
                                return managerUserAnalytics[hotel][date][manager.id].length
                            } else {
                                return 0
                            }
                        }),
                        borderColor: Graph.Colors[mIndex],
                        backgroundColor: Graph.Colors[mIndex],
                        ...Graph.ExtraOptions,
                        stack: `Stack - ${hotel}`
                    };
                })
            }).flat()
        }

        return sHotels.map((hotel, index) => {
            return {
                label: hotel,
                data: allDates.map((date) => {
                    if (managerUserAnalytics[hotel][date]) {
                        return Object.entries(managerUserAnalytics[hotel][date])
                            .filter(it => managerIds.includes(it[0])).map(it => it[1]).flat().length
                    } else {
                        return 0
                    }
                }),
                borderColor: Graph.Colors[index],
                backgroundColor: Graph.Colors[index],
                ...Graph.ExtraOptions,
            }
        })
    } else if (isHotelSummed && !isDateSummed) {

        if (isBar) {
            return selectedManagers.map((manager, mIndex) => {
                return {
                    label: `${manager.name}`,
                    data: allDates.map((date) => {
                        return sHotels.reduce((acc, hotel) => {
                            if (managerUserAnalytics[hotel][date] && managerUserAnalytics[hotel][date][manager.id]) {
                                return acc + managerUserAnalytics[hotel][date][manager.id].length
                            } else {
                                return acc
                            }
                        }, 0)
                    }),
                    borderColor: Graph.Colors[mIndex],
                    backgroundColor: Graph.Colors[mIndex],
                    ...Graph.ExtraOptions,
                    stack: `All Hotels`
                };
            }).flat()
        }

        return [
            {
                label: `All Hotels`,
                data: allDates.map((date) => {
                    return sHotels.reduce((acc, cur) => {
                        if (managerUserAnalytics[cur][date]) {
                            return acc + Object.entries(managerUserAnalytics[cur][date])
                                .filter(it => managerIds.includes(it[0])).map(it => it[1]).flat().length
                        } else {
                            return acc
                        }
                    }, 0)
                }),
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
            }
        ]
    } else if (!isHotelSummed && isDateSummed) {

        if (isBar) {
            return selectedManagers.map((manager, mIndex) => {
                return {
                    label: `${manager.name}`,
                    data: sHotels.map(hotel => {
                        let allData = Object.keys(managerUserAnalytics[hotel]).reduce((acc, date) => {
                            if (managerUserAnalytics[hotel][date] && managerUserAnalytics[hotel][date][manager.id]) {
                                return acc + managerUserAnalytics[hotel][date][manager.id].length
                            } else {
                                return acc
                            }
                        }, 0)
                        return allData
                    }),
                    borderColor: Graph.Colors[mIndex],
                    backgroundColor: Graph.Colors[mIndex],
                    ...Graph.ExtraOptions,
                }
            })
        }

        return [
            {
                label: `All Dates`,
                data: sHotels.map(hotel => {
                    let allData = Object.keys(managerUserAnalytics[hotel]).reduce((acc, date) => {
                        return acc + Object.entries(managerUserAnalytics[hotel][date])
                            .filter(it => managerIds.includes(it[0])).map(it => it[1]).flat().length
                    }, 0)
                    return allData
                }),
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
            }
        ]

    } else if (isHotelSummed && isDateSummed) {
        if (isBar) {
            return selectedManagers.map((manager, mIndex) => {
                return {
                    label: `${manager.name}`,
                    data: [allDates.reduce((acc, date) => {
                        return acc + sHotels.reduce((acc, hotel) => {
                            if (managerUserAnalytics[hotel][date] && managerUserAnalytics[hotel][date][manager.id]) {
                                return acc + managerUserAnalytics[hotel][date][manager.id].length
                            } else {
                                return acc
                            }
                        }, 0)
                    }, 0)],
                    borderColor: Graph.Colors[mIndex],
                    backgroundColor: Graph.Colors[mIndex],
                    ...Graph.ExtraOptions,
                    stack: `All`
                };
            }).flat()
        }
        return [
            {
                label: `All Hotels and Dates`,
                data: [allDates.reduce((acc, date) => {
                    return acc + sHotels.reduce((acc, cur) => {
                        if (managerUserAnalytics[cur][date]) {
                            return acc + Object.entries(managerUserAnalytics[cur][date])
                                .filter(it => managerIds.includes(it[0])).map(it => it[1]).flat().length
                        } else {
                            return acc
                        }
                    }, 0)
                }, 0)],
                borderColor: Graph.Colors[0],
                backgroundColor: Graph.Colors[0],
                ...Graph.ExtraOptions,
            }
        ]
    }
}

export default managerAnalyticsDataFinder